import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';

const modalStyle = {
  width: '500px',
  height: '300px',
  marginLeft: '-10%'
}

const propTypes = {
  selectedRows: PropTypes.array,
  onSuccess: PropTypes.func,
}

const defaultProps = {
  onSuccess: () => { },
  selectedRows: [],
}

class PromotionAdding extends Component {
  handleConfirmClick = () => {
    this.props.onClose();
    this.props.onConfirm();
  }
  render() {
    let filterdPromotion = this.props.productPromotions.filter(p => p.Method === "BuyAGetB" && p.IsPercent && p.Off === 100);
    return (
      <div style={{ width: '100%', height: '100%', padding: '10px' }}>
        <h4>Apply Promotion?</h4>
        {
          _.map(filterdPromotion, promotion => {
            return <div>{promotion.DiscountDescription}</div>
          })
        }
        <div style={{ position: 'absolute', bottom: '30px', right: '20px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            // disabled={selectedRows.length !== 1}
            onClick={() => {
              this.handleConfirmClick();
            }}
          >
            {/* <em className="fa fa-pencil" /> */}
            <Translate value="apply" />
          </Button>
        </div>
      </div>
    )
  }
}

const PromotionAddingModal = ({ onClose, isVisible, onConfirm, productPromotions }) => (
  <SkyLightStateless
    title={'Promotion Found'}
    onCloseClicked={onClose}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <PromotionAdding onClose={onClose} onConfirm={onConfirm} productPromotions={productPromotions} />
  </SkyLightStateless>
)

PromotionAddingModal.propTypes = propTypes
PromotionAddingModal.defaultProps = defaultProps

export default PromotionAddingModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/PromotionAddingModal.jsx